import React, { useCallback, useEffect, useState } from "react";
import ParticipantTable from "../../library/ParticipantTable/ParticipantTable";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
  participantsReducer,
} from "./ParticipantTable.store";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import SmartAddParticipant from "../AddParticipant/AddParticipant";
import { smoothScrollToTop } from "../../../modules/utils";

export const SmartParticipantTable = (props) => {
  const {
    siteId,
    searchedParams,
    totalItems,
    participants,
    fetchParticipants,
    canViewParticipantPage,
    canCreateParticipant,
    canEditParticipant,
    canViewParticipantTemporaryPassword,
    canChangeStudyStatus,
    canViewStudyStatus,
    studyId,
    canViewPersonalData,
    resetState,
    fetchEntriesData,
    canGenerateReport,
    canManageUsers,
    loading,
    canCreate24hRecall,
    canCreatePaperRecapture,
    fetchDailyTargetHistory,
  } = props;

  const [showAddParticipantModal, setShowAddParticipantModal] = useState(false);

  const getData = useCallback(
    (params) => {
      fetchParticipants(siteId, params, studyId)
        .catch((error) => {
          sendNotification(error, ToastType.ERROR);
        })
        .finally(() => {
          if (params.limit !== searchedParams.limit) {
            smoothScrollToTop();
          }
        });
    },
    [siteId, studyId, fetchParticipants, searchedParams]
  );

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const closeAddParticipantModal = () => {
    setShowAddParticipantModal(false);
    getData(searchedParams);
  };

  const addParticipant = () => {
    setShowAddParticipantModal(true);
  };

  useEffect(() => {
    if (totalItems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  const onRefreshData = useCallback(() => {
    getData(searchedParams);
  }, [getData, searchedParams]);

  return (
    <>
      <CustomModal
        show={showAddParticipantModal}
        title="Add New Participant"
        onClose={() => setShowAddParticipantModal(false)}
      >
        <SmartAddParticipant
          onClose={closeAddParticipantModal}
          {...{ studyId }}
          {...{ siteId }}
        />
      </CustomModal>

      <ParticipantTable
        {...{ getData }}
        {...{ searchedParams }}
        totalitems={totalItems}
        loading={loading}
        {...{ participants }}
        {...{ addParticipant }}
        {...{ canViewParticipantPage }}
        {...{ canCreateParticipant }}
        {...{ canEditParticipant }}
        {...{ canViewParticipantTemporaryPassword }}
        {...{ canChangeStudyStatus }}
        {...{ canViewStudyStatus }}
        {...{ canViewPersonalData }}
        {...{ canGenerateReport }}
        {...{ canManageUsers }}
        {...{ fetchEntriesData }}
        {...{ studyId }}
        refreshData={onRefreshData}
        {...{ canCreate24hRecall }}
        {...{ canCreatePaperRecapture }}
        {...{ fetchDailyTargetHistory }}
      />
    </>
  );
};

export default dynamic(
  "participantsReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(participantsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartParticipantTable));
